import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Pagination from '../../CommonUI/Pagination/Pagination';
import './Schemecomparison.css';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function Schemecomparison() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [DataFundPerformance, setDataFundPerformance] = useState([]);
    const [DataMfHoldingdropCatDivi, setDataMfHoldingdropCatDivi] = useState([]);
    const [MFCode, setMFCode] = useState('10645');
    const [MFCodee, setMFCodee] = useState('27783');
    const [Shemedrop, setSheme] = useState('26');
    const [Value1, setValue1] = useState([]);
    const [Value2, setValue2] = useState([]);
    const [Value3, setValue3] = useState([]);
    // const [Schemename, setSchemename] = useState('6502');
    let getDataHoldingdrop, PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";
      
        fetch(`${getUrlMfTopHoldingDropDividend}/compare/-`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataFundPerformance(getDataHoldingdrop);
                var codename = getDataHoldingdrop[0].VCLASS;
                setValue1(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });


       
        fetch(`${getUrlMfTopHoldingDropDividend}/compare/${Shemedrop}`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataMfHoldingdropCatDivi(getDataHoldingdrop);
                var codename = getDataHoldingdrop[0].SCH_NAME;
                setValue2(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

   
        fetch(`${getUrlMfTopHoldingDropDividend}/compare/${Shemedrop}`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataMfHoldingdropCatDivi(getDataHoldingdrop);
                var codename = getDataHoldingdrop[5].SCH_NAME;
                setValue3(codename)
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });


        const getUrl = BaseURL + "Schemecomparison";
    
        fetch(`${getUrl}/${MFCode}/${MFCodee}`)
            .then((response) => response.json())
            .then((data) => {

                setData(data.data);
                setloadingshow(false);
                // console.log(data.data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, [Shemedrop, MFCode, MFCodee]);
    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }

    return (
        <>
        <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Scheme Comparison</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='scheme-loser-sc'>
                            <div className='scheme-header'>
                                <h2><span>Scheme Comparison</span></h2>
                            </div>
                            <MarketMF optionValue="Scheme comparison" />
                            <div className='scheme-right'>
                                <div className='scheme-inner-select'>

                                    {/* aria-label="Select Category" */}
                                    <select aria-label="Select Category" onChange={(event) => setSheme(event.target.value)}>
                                        <option>Select Category</option>
                                        {DataFundPerformance && DataFundPerformance.map(
                                            ({ VCLASSCODE, VCLASS }) => (
                                                <option value={VCLASSCODE} selected={Value1 === VCLASS}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className='scheme-inner-select'>

                                   {/* aria-label="Select a Scheme" */}
                                    <select aria-label="Select a Scheme" onChange={(event) => setMFCode(event.target.value)}>
                                        <option>Select a Scheme</option>
                                        {DataMfHoldingdropCatDivi && DataMfHoldingdropCatDivi.map(
                                            ({ SCH_NAME, MF_SCHCODE }) => (
                                                <option value={MF_SCHCODE} selected={Value2 === SCH_NAME}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className='scheme-inner-select'>

                                      {/* aria-label="Select a Scheme" */}      
                                    <select aria-label="Select a Scheme" onChange={(event) => setMFCodee(event.target.value)}>
                                        <option>Select a Scheme</option>
                                        {DataMfHoldingdropCatDivi && DataMfHoldingdropCatDivi.map(
                                            ({ SCH_NAME, MF_SCHCODE }) => (
                                                <option value={MF_SCHCODE} selected={Value3 === SCH_NAME}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='scheme-table table-responsive'>
                                <table className='table'>
                                    {(currentTableData != null) ?
                                        <thead>
                                            <tr>
                                                <th className="bdrright"><h6>Scheme</h6></th>
                                                <th className="bdrright"><h6 className="schemeRoute" onClick={() => routeChange(currentTableData[0].Sch_Name)}>{currentTableData[0].Sch_Name}</h6></th>
                                                <th ><h6 className="schemeRoute" onClick={() => routeChange(currentTableData[1].Sch_Name)}>{currentTableData[1].Sch_Name}</h6></th>
                                            </tr>

                                        </thead> : ''}

                                    {(currentTableData != null) ?
                                        <tbody>

                                            <tr>
                                                <td className="bdrright">AMC</td>
                                                <td className="bdrright">{(currentTableData[0].Co_Name != null) ? currentTableData[0].Co_Name : '-'}</td>
                                                <td >{(currentTableData[1].Co_Name != null) ? currentTableData[1].Co_Name : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Category</td>
                                                <td className="bdrright">{(currentTableData[0].VClass != null) ? currentTableData[0].VClass : '-'}</td>
                                                <td>{(currentTableData[1].VClass != null) ? currentTableData[1].VClass : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Scheme Assets(Rs in cr)</td>
                                                <td className="bdrright">{(currentTableData[0].SchemeAssets != null) ? currentTableData[0].SchemeAssets : '-'}</td>
                                                <td>{(currentTableData[1].SchemeAssets != null) ? currentTableData[1].SchemeAssets : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Launch Date</td>
                                                <td className="bdrright">{format(parseISO(currentTableData[0].INCFROM), 'dd-MMM-yyyy')}</td>
                                                <td>{format(parseISO(currentTableData[1].INCFROM), 'dd-MMM-yyyy')}</td>

                                            </tr>
                                            <tr>
                                                <td className="bdrright">Last NAV(Rs)</td>
                                                <td className="bdrright">({(currentTableData[0].NAVRS != null) ? currentTableData[0].NAVRS.toFixed(2) : '-' }){format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy')}</td>
                                                <td>({(currentTableData[1].NAVRS != null) ? currentTableData[1].NAVRS.toFixed(2) : '-' }){format(parseISO(currentTableData[1].NavDate), 'dd-MMM-yyyy')}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Last dividend(%)</td>
                                                <td className="bdrright">{(currentTableData[0].Dividend != null) ? currentTableData[0].Dividend : '-'}</td>
                                                <td>{(currentTableData[1].Dividend != null) ? currentTableData[1].Dividend : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Minimum Investment(Rs)</td>
                                                <td className="bdrright">{(currentTableData[0].MinInvestment != null) ? currentTableData[0].MinInvestment.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].MinInvestment != null) ? currentTableData[1].MinInvestment.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Entry Load</td>
                                                <td className="bdrright">{(currentTableData[0].EntryLoad != null) ? currentTableData[0].EntryLoad : '-'}</td>
                                                <td>{(currentTableData[1].EntryLoad != null) ? currentTableData[1].EntryLoad : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Exit Load</td>
                                                <td className="bdrright">{(currentTableData[0].ExitLoad != null) ? currentTableData[0].ExitLoad : '-'}</td>
                                                <td>{(currentTableData[1].ExitLoad != null) ? currentTableData[1].ExitLoad : '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Fund Manager</td>
                                                <td className="bdrright">{(currentTableData[0].FundManager != null) ? currentTableData[0].FundManager : '-'}</td>
                                                <td>{(currentTableData[1].FundManager != null) ? currentTableData[1].FundManager : '-'}</td>
                                            </tr>

                                        </tbody> : ''}

                                </table>
                                {/* {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    } */}
                            </div>
                            <div className='scheme-table table-responsive'>
                                <table className='table'>

                                    <thead>
                                        <tr>
                                            <th>Absolute Returns</th>
                                            <th></th>
                                            <th></th>

                                        </tr>

                                    </thead>

                                    {(currentTableData != null) ?
                                        <tbody>


                                            <tr>
                                                <td className="bdrright">1 Week(%)</td>
                                                <td className="bdrright">{(currentTableData[0].week1 != null) ? currentTableData[0].week1.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].week1 != null) ? currentTableData[1].week1.toFixed(2) : '-' }</td>
                                            

                                            </tr>
                                            <tr>
                                                <td className="bdrright">1 Month(%)</td>
                                                <td className="bdrright">{(currentTableData[0].month1 != null) ? currentTableData[0].month1.toFixed(2) : '-' }</td>
                                                <td >{(currentTableData[1].month1 != null) ? currentTableData[1].month1.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">3 Months(%)</td>
                                                <td className="bdrright">{(currentTableData[0].month3 != null) ? currentTableData[0].month3.toFixed(2) : '-' }</td>
                                                <td >{(currentTableData[1].month3 != null) ? currentTableData[1].month3.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">6 Months(%)</td>
                                                <td className="bdrright">{(currentTableData[0].month6 != null) ? currentTableData[0].month6.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].month6 != null) ? currentTableData[1].month6.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">1 Year(%)</td>
                                                <td className="bdrright">{(currentTableData[0].year1 != null) ? currentTableData[0].year1.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].year1 != null) ? currentTableData[1].year1.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">3 Years(%)</td>
                                                <td className="bdrright">{(currentTableData[0].year3 != null) ? currentTableData[0].year3.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].year3 != null) ? currentTableData[1].year3.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">5 Years(%)</td>
                                                <td className="bdrright">{(currentTableData[0].year5 != null) ? currentTableData[0].year5.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].year5 != null) ? currentTableData[1].year5.toFixed(2) : '-' }</td>
                                            </tr>
                                            <tr>
                                                <td className="bdrright">Since Inception(%)</td>
                                                <td className="bdrright">{(currentTableData[0].INCEPTION != null) ? currentTableData[0].INCEPTION.toFixed(2) : '-' }</td>
                                                <td>{(currentTableData[1].INCEPTION != null) ? currentTableData[1].INCEPTION.toFixed(2) : '-' }</td>
                                            </tr>

                                        </tbody> : ''}
                                </table>
                               
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Schemecomparison;